import { render, staticRenderFns } from "./DaftarPeriksa.vue?vue&type=template&id=2ada16c4&lang=pug&"
import script from "./DaftarPeriksa.vue?vue&type=script&lang=js&"
export * from "./DaftarPeriksa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports